import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

export const SpinMap = ({ points }) => {
  if (!points?.length) return null;
  return (
    <div data-testid="spin-map" className="rounded-xl overflow-hidden border border-border/60" style={{ height: 320 }}>
      <MapContainer center={[36.5, -96.6]} zoom={4} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {points.map((p, i) => (
          <CircleMarker
            key={i}
            center={[p.lat, p.lng]}
            radius={7}
            pathOptions={{ color: p.converted ? "#2F5D50" : "#B05C3B", fillColor: p.converted ? "#2F5D50" : "#B05C3B", fillOpacity: 0.75, weight: 1.5 }}
          >
            <Tooltip>
              {p.city || "Unknown location"} — {p.code}{p.converted ? " · Booked a stay" : ""}
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
};
